import React from 'react';
import './FormBase.css';

export default function FormBase(prop) {
  const ball1_path = process.env.PUBLIC_URL + '/img/form_ball1.svg';
  const ball2_path = process.env.PUBLIC_URL + '/img/form_ball2.svg';
  const ball3_path = process.env.PUBLIC_URL + '/img/form_ball3.svg';
  const ball4_path = process.env.PUBLIC_URL + '/img/form_ball2.svg';

  return (
    <div className={'mainContainer formBackground'}>
      <div className={'form'} >
        <div className={'title'}>
          {prop.title}
        </div>
        <div className={'ball1'} >
          <div className={'content'} >
            <img src={ball1_path} alt={'ball 1'} width={'100%'} height={'100%'} />
          </div>
        </div>
        <div className={'ball2'} >
          <div className={'content'} >
            <img src={ball2_path} alt={'ball 2'} width={'100%'} height={'100%'} />
          </div>
        </div>
        <div className={'ball3'} >
          <div className={'content'} >
            <img src={ball3_path} alt={'ball 3'} width={'100%'} height={'100%'} />
          </div>
        </div>
        <div className={'ball4'} >
          <div className={'content'} >
            <img src={ball4_path} alt={'ball 4'} width={'100%'} height={'100%'} />
          </div>
        </div>
        <div className={'dialog'} />
        <div className={'baseContent'}>
          {prop.children}
        </div>
      </div>
    </div>
  )
}